const listaPaginasCMS = [
  'ListaContatos',
  'ListaPublicacoes',
  'ListaPaginas',
  'ListaRevistas',
  'ListaNoticias',
  'ListaEventos',
  'CentralLog',
  'ListaTermosUso',
  'ListaBanners',
  'ListaPermalink'
]

const getExternalUrl = (targetPage, { authorization, idConfigClienteApp }) => {
  let url = ''
  if (listaPaginasCMS.includes(targetPage)) {
    const refererUrl = process.env[`VUE_APP_CMS_URL_${targetPage.toUpperCase()}`]
    url = `${process.env.VUE_APP_CMS_URL}?referer_url=${refererUrl}&token=${authorization}&id_config_cliente_app=${idConfigClienteApp}`
  } else if (targetPage === 'FormBuilder') {
    url = `${process.env.VUE_APP_FORMBUILDER_SSO}?token=${authorization}`
  } else if (targetPage === 'AtendimentoGestao') {
    url = `${process.env.VUE_APP_MOSIA_ADMIN}/login/sso?token=${authorization}&sandbox=true&referer_url=${process.env.VUE_APP_MOSIA_ADMIN}/home`
  } else if (targetPage === 'AtendimentoGestaoTiposEncerramento') {
    url = `${process.env.VUE_APP_MOSIA_ADMIN}/login/sso?token=${authorization}&sandbox=true&referer_url=${process.env.VUE_APP_MOSIA_ADMIN}/tipoEncerramento`
  } else if (targetPage === 'AbrirChamado') {
    url = `${process.env.VUE_APP_SERVICEDESK_URL}`
  } else if (targetPage === 'Documentacao') {
    url = `${process.env.VUE_APP_DOCUMENTACAO_URL}`
  } else if (targetPage === 'DownloadAppSandbox') {
    url = `${process.env.VUE_APP_PAGE_DOWNLOAD_APP_SANDBOX}`
  } else if (targetPage === 'PainelAtendente') {
    url = `${process.env.VUE_APP_PAINEL_ATENDENTE}`
  } else if (targetPage === 'SiteInstitucional') {
    url = `${process.env.VUE_APP_SITE_INSTITUCIONAL}`
  } else if (targetPage === 'PainelAtendenteSandbox') {
    url = `${process.env.VUE_APP_PAINEL_ATENDENTE_SANDBOX}`
  } else if (targetPage === 'SiteInformativos') {
    url = `${process.env.VUE_APP_SITE_INFORMATIVOS}`
  } else if (targetPage === 'NovoPainelAtendente') {
    url = `${process.env.VUE_APP_NOVO_PAINEL_ATENDENTE}`
  } else if (targetPage === 'NovoPainelAtendenteSandbox') {
    url = `${process.env.VUE_APP_NOVO_PAINEL_ATENDENTE_SANDBOX}`
  }

  return url
}

export default getExternalUrl
